import { ChangeDetectionStrategy, Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { ItemDetailCardDataModel } from '../../../../models/item-detail-card.model';
import { TranslateService } from '@ngx-translate/core';
import { IonToggle } from '@ionic/angular';

/**
 * Item Detail Card Component
 * Displays item details with status toggle and arrow icon for navigation
 */
@Component({
  selector: 'item-detail-card',
  templateUrl: 'item-detail-card.html',
  styleUrls: ['item-detail-card.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ItemDetailCardComponent {
  @Input() itemData: ItemDetailCardDataModel;
  @Input() isOffline: boolean = false;
  @Input() isOneKeySearching: boolean = false;
  @Input() readOnly: boolean = false;
  @Input() signatureIconPath: string = 'assets/imgs/capture_sign.svg';

  @Output() onSignatureClick = new EventEmitter<ItemDetailCardDataModel>();
  @Output() onStatusToggleClick = new EventEmitter<{
    itemData:ItemDetailCardDataModel, 
    childRef?: ItemDetailCardComponent
  }>();

  @ViewChild('toggle', { static: true }) toggleRef!: IonToggle;

  constructor(
    public translate: TranslateService) {}


  get isToggleDisabled(): boolean {
    return !this.itemData?.isOptedIn || this.isOffline || this.isOneKeySearching;
  }

  /**
   * Handle status toggle click
   */
  handleStatusToggleClick(event: Event) {
    event.stopPropagation();
    if (!this.isToggleDisabled) {
      this.onStatusToggleClick.emit({
        itemData: this.itemData,
        childRef: this
      });
    }
  }

  /**
   * Handle arrow icon click
   */
  handleSignatureClick(event: Event) {
    event.stopPropagation();
    // Only allow navigation when opted in and has signature
    if (!this.itemData?.isOptedIn || !this.itemData.hasSignature) {
      return;
    }
    this.onSignatureClick.emit(this.itemData);
  }

  /**
   * Handle card click (except on toggle)
   */
  handleCardClick(event: Event) {
    // Don't trigger if clicking on toggle
    const target = event.target as HTMLElement;
    if (target.closest('ion-toggle') || target.closest('ion-icon')) {
      return;
    }
    // Trigger the same behavior as arrow icon click
    // Only allow navigation when opted in and has signature
    if (!this.itemData?.isOptedIn || !this.itemData.hasSignature) {
      return;
    }
    this.handleSignatureClick(event);
  }

  revertTo(value: boolean) {
    if (this.toggleRef) {
      this.toggleRef.checked = value;
    }
  }
}

